import { render, staticRenderFns } from "./actIntro.vue?vue&type=template&id=0ca58b27&scoped=true"
import script from "./actIntro.vue?vue&type=script&lang=js"
export * from "./actIntro.vue?vue&type=script&lang=js"
import style0 from "./actIntro.vue?vue&type=style&index=0&id=0ca58b27&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca58b27",
  null
  
)

export default component.exports